module.exports = __webpack_public_path__ + "img/OldCustomerTitle.5e9dbbe9.png";